export const _setAdminLists = (state, action) => {
  state.adminLinkLists = action.payload;
};

export const _setViewEngagementLists = (state, action) => {
  state.viewEngagementLists = action.payload;
};

export const _setViewEngagementLinkId = (state, action) => {
  state.viewEngagementLinkId = action.payload;
};

export const _setViewUnviewUsers = (state, action) => {
  state.viewUnviewUsers = action.payload;
};
